export const isUnrestrictedOrganizationPlan = (plan) =>
  String(plan?.name ?? plan ?? "").trim().toLowerCase() === "admin"

export const hasUnrestrictedProductAccess = ({ userRole, plan }) =>
  userRole === "admin" || isUnrestrictedOrganizationPlan(plan)
